import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, mergeMap } from 'rxjs/operators'

import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { GET_DEFAULT_TRAINING_DATA_ASYNC } from '../../WizardTrainingCampaign/constants'
import { buildTrainingIdsParam } from '../../WizardTrainingCampaign/playlist'
import { selectDefaultLocaleId, selectSelectedTrainingVideo } from '../selectors'
import { AUTOMATED_LEVEL_BASED_TRAINING } from '../TrainingModuleStep/constants'

import {
  getDefaultTrainingDataError,
  getDefaultTrainingDataSuccess,
  getEmailPreviewError,
  getEmailPreviewSuccess,
  validateMessageStep,
} from './actions'
import { GET_EMAIL_PREVIEW_ASYNC } from './constants'

const getDefaultTrainingDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_DEFAULT_TRAINING_DATA_ASYNC.INITIATE),
    mergeMap(() =>
      api.wizardCampaign
        .getDefaultTrainingData(
          selectCompanyFilter(state$.value)?.value,
          selectDefaultLocaleId(state$.value),
          buildTrainingIdsParam(selectSelectedTrainingVideo(state$.value))
        )
        .pipe(
          mergeMap((response) =>
            of(getDefaultTrainingDataSuccess(response), validateMessageStep())
          ),
          catchError((error) => of(epicsErrorHandler(getDefaultTrainingDataError, error, [400])))
        )
    )
  )

const getEmailPreviewEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_EMAIL_PREVIEW_ASYNC.INITIATE),
    mergeMap((action) => {
      const { data } = action.payload

      return api.wizardCampaign
        .getEmailPreview(
          {
            message: data.message,
            includeLogo: data.includeLogo,
            useDesignedImage: data.useDesignedImage,
            trainingIds: data.trainingIds.filter((id) => id !== AUTOMATED_LEVEL_BASED_TRAINING.id),
            mailSignature: data.mailSignature,
            localeId: data.localeId,
            subject: data.subject,
            campaignName: data.campaignName,
          },
          selectCompanyFilter(state$.value)?.value
        )
        .pipe(
          mergeMap((response) => of(getEmailPreviewSuccess(response))),
          catchError((error) => of(epicsErrorHandler(getEmailPreviewError, error, [400])))
        )
    })
  )

export default combineEpics(getDefaultTrainingDataEpic, getEmailPreviewEpic)
